import { useState } from 'react';
import ApiService from '../ApiService';
import * as db from '../cache/db';
import { storyKey } from '../cache/routePreCache';
import { trackEvent } from '../analytics';

const INITIAL_STATE = {
  isOpen: false,
  story: null,
  place: null,
  loading: false,
  audio: null,
  audioLoading: false,
  isPlaying: false,
  autoplay: false,
};

export default function useStoryModal({ user, i18n }) {
  const [storyModal, setStoryModal] = useState(INITIAL_STATE);
  const [selectedPlace, setSelectedPlace] = useState(null);

  const fetchPlaceStory = async (place, autoplay = false) => {
    setStoryModal({ isOpen: true, story: null, place, loading: true, audio: null, audioLoading: false, isPlaying: false, autoplay });

    try {
      const ref = place.place_ref || place.reference;
      const lang = i18n.language;

      // Cache-first: use cached story if available
      const cached = await db.get(storyKey(ref, lang));
      if (cached) {
        setStoryModal(prev => ({ ...prev, story: cached, loading: false, autoplay }));
        return;
      }

      const storyData = await ApiService.post('/place/story/', {
        place_id: place.id,
        place_ref: ref,
        language: lang,
      }, user);

      if (storyData) {
        setStoryModal(prev => ({ ...prev, story: storyData, loading: false, autoplay }));
      } else {
        console.error('Failed to fetch story');
        setStoryModal(prev => ({ ...prev, loading: false, autoplay }));
      }
    } catch (error) {
      console.error('Error fetching story:', error);
      setStoryModal(prev => ({ ...prev, loading: false, autoplay }));
    }
  };

  const handlePlaceCardClick = (place, autoplay = false) => {
    trackEvent('place_story_opened', {
      place_name: place.description?.name,
      place_types: place.types?.[0],
    });
    fetchPlaceStory(place, autoplay);
  };

  const handleMarkerClick = (place) => {
    setSelectedPlace(place);
  };

  const closeStoryModal = () => {
    if (storyModal.audio) {
      storyModal.audio.pause();
    }
    setStoryModal(INITIAL_STATE);
  };

  return {
    storyModal,
    setStoryModal,
    selectedPlace,
    fetchPlaceStory,
    handlePlaceCardClick,
    handleMarkerClick,
    closeStoryModal,
  };
}
